import { render } from "./SmartChannelIcon.vue?vue&type=template&id=2565a1d5&lang=html"
import script from "./SmartChannelIcon.vue?vue&type=script&lang=js"
export * from "./SmartChannelIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__